import JoinPremiumScreen from '@/screens/join-premium/JoinPremiumScreen'

export default function () {
  return <JoinPremiumScreen />
}
